import { Router } from '@angular/router';
import { AuthService } from './services/auth.service';
import { FcmService } from './services/fcm.service';
import { Component, OnInit, OnDestroy } from '@angular/core';

import { Platform, MenuController } from '@ionic/angular';
import { SplashScreen } from '@ionic-native/splash-screen/ngx';
import { StatusBar } from '@ionic-native/status-bar/ngx';

@Component({
  selector: 'app-root',
  templateUrl: 'app.component.html',
  styleUrls: ['app.component.scss'],
})
export class AppComponent implements OnInit {
  public selectedIndex = 0;

  public appPages = [
    {
      title: 'Admin',
      url: '/admin',
      icon: '🚀',
      type: 'admin',
    },

    {
      title: 'JagaCarePackage',
      url: '/carepackage-admin',
      icon: '💜',
      type: 'admin',
    },
    {
      title: 'CarePackageForm',
      url: '/carepackage-public',
      icon: '💖',
      type: 'admin',
    },
    {
      title: 'Dashboard',
      url: '/home',
      icon: '🏠',
      type: 'public',
    },

    //Add profile
    //Add Notification
  ];
  user;

  constructor(
    private platform: Platform,
    private splashScreen: SplashScreen,
    private statusBar: StatusBar,
    public fcm: FcmService,
    public auth: AuthService,
    private menuController: MenuController,
    private router: Router
  ) {
    this.initializeApp();
  }

  initializeApp() {
    this.platform.ready().then(() => {
      this.statusBar.styleDefault();
      this.splashScreen.hide();

      this.fcm.listenToMessages().subscribe();
    });
  }

  ngOnInit() {
    this.user = this.auth.user$;

    if (this.user.uid) {
      this.fcm.getPermission(this.user.uid);
    }

    const path = window.location.pathname.split('folder/')[1];
    if (path !== undefined) {
      this.selectedIndex = this.appPages.findIndex(
        (page) => page.title.toLowerCase() === path.toLowerCase()
      );
    }
  }

  signOut() {
    this.auth.signOut().then(() => {
      this.menuController.close();
    });
  }

  showTutorial() {
    this.router.navigateByUrl('/tutorial');
    this.menuController.close();
  }
}
